// https://vuex.vuejs.org/en/mutations.html

import Vue from 'vue'

export default {
  //

  SET_DEBUG (state, val) {
    state.debug = val
  },
  CLEAR_DEBUG (state) {
    state.debug = false
  },

  SET_LOADING (state) {
    state.loading = true
  },
  CLEAR_LOADING (state) {
    state.loading = false
  },

  SET_MENU_CONTROL (state, val) {
    state.menuControl = val
  },
  CLEAR_MENU_CONTROL (state) {
    state.menuControl = false
  },

  SET_IS_LOGGED (state) {
    state.isLogged = true
  },
  CLEAR_IS_LOGGED (state) {
    state.isLogged = false
  },

  SET_NOTIFY_MESSAGE (state, value) {
    state.notifyMessage = value
  },
  CLEAR_NOTIFY_MESSAGE (state) {
    state.notifyMessage = null
  },

  SET_USER (state, value) {
    state.firebaseUser = value
  },
  CLEAR_USER (state) {
    state.firebaseUser = null
  },

  SET_UID (state, value) {
    state.uid = value
  },
  CLEAR_UID (state) {
    state.uid = null
  },

  SET_EMAIL (state, value) {
    state.email = value
  },
  CLEAR_EMAIL (state) {
    state.email = null
  },

  SET_DISPLAY_NAME (state, value) {
    state.displayName = value
  },
  CLEAR_DISPLAY_NAME (state) {
    state.displayName = null
  },

  SET_LEVEL (state, value) {
    state.level = value
  },
  CLEAR_LEVEL (state) {
    state.level = 0
  },


  SET_NOTIFY_TIMEOUT (state, value) {
    state.notifyTimeout = value
  },
  CLEAR_NOTIFY_TIMEOUT (state) {
    state.notifyTimeout = 3000
  },

  SET_ALL_PRODUCTS (state, value) {
    state.allProducts = value
  },
  CLEAR_ALL_PRODUCTS (state) {
    state.allProducts = []
  },

  SET_THIS_ORDER (state, value) {
    state.thisOrder = value
  },
  CLEAR_THIS_ORDER (state) {
    state.thisOrder = []
  },
  ADD_THIS_ORDER (state, value) {
    // state.thisOrder.push(value)
    Vue.set(state.thisOrder, state.thisOrder.length, {...value, index: state.thisOrder.length})
  },
  UPDATE_THIS_ORDER (state, payload) {
    //payload = {
    //   index = <>
    //   value = {}
    // }
    Vue.set(state.thisOrder, payload.index, {...payload.value, index: payload.index})
  },
  REMOVE_THIS_ORDER (state, index) {
    state.thisOrder.splice(index,1)
    
    // reindex the array
    state.thisOrder.forEach((element, i) => {
      element.index = i 
    })
  }

  
}
